import React from "react"
import { useNavigate } from "react-router-dom"
import {
  BarContainer,
  RuleName
} from "./DiscountRuleBar.styled"

export interface DiscountRuleData {
  ruleId: string
  ruleName: string
  ruleType: "code" | "cart" | "external"
  validFrom: string
  validTo: string
  sortOrder: number
}

interface DiscountRuleBarProps {
  color: string
  width: string
  start: string
  ruleId: string
  ruleName: string
  ruleType: "code" | "cart" | "external"
  validFrom: string
  validTo: string
  sortOrder: number
  showName: boolean
  isPreview?: boolean
  isLongTerm?: boolean
  onHoverStart: (data: DiscountRuleData) => void
  onHoverEnd: () => void
}

const DiscountRuleBar: React.FC<DiscountRuleBarProps> = ({
  color,
  width,
  start,
  ruleId,
  ruleName,
  ruleType,
  validFrom,
  validTo,
  sortOrder,
  showName,
  isPreview = false,
  isLongTerm = false,
  onHoverStart,
  onHoverEnd
}) => {
  const widthPercent = parseFloat(width)
  const shouldShowName = showName && widthPercent > 3
  const navigate = useNavigate()

  const getNavigationPath = () => {
    switch (ruleType) {
      case "code":
        return `/discounts/discount-code-rules/${ruleId}`
      case "cart":
        return `/discounts/cart-rules/${ruleId}`
      case "external":
        return `/discounts/external-rules/${ruleId}`
      default:
        return ""
    }
  }

  const handleClick = () => {
    if (!isPreview) {
      navigate(getNavigationPath())
    }
  }

  return (
    <BarContainer
      onClick={handleClick}
      onMouseEnter={() => onHoverStart({ ruleId, ruleName, ruleType, validFrom, validTo, sortOrder })}
      onMouseLeave={onHoverEnd}
      $color={color}
      $width={width}
      $start={start}
      $isLongTerm={isLongTerm}
      data-tooltip-id="discount-rule-timeline-tooltip"
    >
      {shouldShowName && <RuleName>[{sortOrder}] {ruleName}</RuleName>}
    </BarContainer>
  )
}

export default DiscountRuleBar
